<template>
  <div>
     <h4 class="marginl10" style="margin-bottom:35px">保险机构管理</h4>
     <div>
       <div style="margin-bottom:15px">
             <!-- 保险机构:

              <el-select v-model="insuranceCompanyId1" @change='suoshuFun' class="marginl10 w213" placeholder="请选择保险公司"
                filterable>
                <el-option v-for="item in companies" :key="item.id" :label="item.insti.name"
                  :value="item.insti.id"  v-if='item.insti.name'></el-option>
              </el-select> -->

             保险公司子公司：<el-input style="display: inline-block;width: 200px;" v-model="seename" placeholder="请输入内容"></el-input>
            <el-button type="primary" style="width: 100px;margin-left:15px;" @click="see()">查询</el-button>
            <el-button type="primary" style="width: 100px;margin-left:15px;float: right;" @click="add()">添加</el-button>
       </div>
         
      
     </div>
      
    <div class="form_box">
      <el-table empty-text="暂无数据" :data="tableData" border>
        <el-table-column label="序号" min-width="10">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="联系人" min-width="25">
          <template slot-scope="scope">
            {{  scope.row.contact }}
          </template>
        </el-table-column>
        <el-table-column label="联系方式" min-width="25">
          <template slot-scope="scope">
            {{  scope.row.contactTel }}
          </template>
        </el-table-column>
        <el-table-column label="保险公司" min-width="25">
          <template slot-scope="scope">
            {{  scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="邮箱" min-width="25">
          <template slot-scope="scope">
            {{ scope.row.email }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="用户名" min-width="25">
          <template slot-scope="scope">
            {{  scope.row.passport }}
          </template>
        </el-table-column> -->
            <el-table-column label="保险机构" min-width="25">
          <template slot-scope="scope">
            {{  scope.row.regulatorIdname }}
          </template>
        </el-table-column>
        <el-table-column prop="op" label="编辑" min-width="25">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
            <!-- <el-button type="text" size="small" @click="dele(scope.row.id)">删除</el-button> -->
            <el-button type="text" size="small" @click="type(scope.row)">添加类型</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

     <el-dialog :title="title" center :visible.sync="dialogFormVisible" width="800px">
      <div class="popBox">
        <!-- <p style="margin-bottom: 15px">救援费用:</p> -->
        <ul>
            <li>
            <span><span style="display: inline;color: red;margin-right: 5px;">*</span>保险公司名称：</span>
            <!-- <el-input type="text" v-model="name"></el-input> -->
            <el-select v-model="insuranceCompanyId" @change='suoshuFun' class="marginl10 w213" placeholder="请选择保险公司"
                filterable>
                <el-option v-if='item.insti.name' v-for="item in companies" :key="item.id" :label="item.insti.name"
                  :value="item.insti.id"></el-option>
              </el-select>
          </li>
          <li>
            <span><span style="display: inline;color: red;margin-right: 5px;">*</span>保险子公司名称：</span>
            <el-input type="text" v-model="name"></el-input>
          </li>
          <li>
            <span>简称：</span>
            <el-input type="text" v-model="shortName"></el-input>
          </li>
          <li>
            <span>联系人：</span>
            <el-input type="text" v-model="contact"></el-input>
          </li>
          <li>
            <span>联系方式：</span>
            <el-input type="text" v-model="contactTel"></el-input>
          </li>
          <li>
            <span>保单号前缀：</span>
            <el-input type="text" v-model="recognitionCode"></el-input>
          </li>
           <!-- <li>
            <span><span style="display: inline;color: red;margin-right: 5px;">*</span>操作联系邮箱：</span>
            <el-input type="text" :disabled="true" v-model="emailA"></el-input>
          </li> -->
          <li>
            <span>操作联系邮箱1：</span>
            <el-input type="text" v-model="email"></el-input>
          </li>
           <li>
            <span>操作联系邮箱2：</span>
            <el-input type="text" v-model="email1"></el-input>
          </li>
          <li>
            <span>操作联系邮箱3：</span>
            <el-input type="text" v-model="email2"></el-input>
          </li>
          <li>
            <span>操作联系邮箱4：</span>
            <el-input type="text" v-model="email3"></el-input>
          </li>
          <li>
            <span>合同截止时间：</span>
            <el-date-picker
              v-model="contractEndTime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </li>
          <!-- <li>
            <span><span style="display: inline;color: red;margin-right: 5px;">*</span>登录账号：</span>
            <el-input type="text" v-model="passport"></el-input>
          </li> -->
        </ul>
      </div>
    	<div slot="footer" class="dialog-footer">
    		<el-button @click="dialogFormVisible = false">取 消</el-button>
    		<el-button type="primary" @click="sureFun()">确 定</el-button>
    	</div>
    </el-dialog>
    <el-dialog
        title="添加类型"
        :visible.sync="dialogVisible"
        width="30%">
        <div>
          <el-checkbox v-model="checked1" @change="checkbox(0,checked1,'疏通马桶服务')" label="疏通马桶服务" border></el-checkbox>
         <el-input v-if="checked1 == true"  onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[0].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px"> 
          <el-checkbox v-model="checked2"  @change="checkbox(1,checked2,'开锁服务')"  label="开锁服务" border></el-checkbox>
          <el-input v-if="checked2 == true"  onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[1].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px">
          <el-checkbox v-model="checked3" @change="checkbox(2,checked3,'油烟机清洗')" label="油烟机清洗" border size="medium"></el-checkbox>
          <el-input v-if="checked3 == true"  onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[2].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px">
          <el-checkbox v-model="checked4" @change="checkbox(3,checked4,'油烟机拆洗')" label="油烟机拆洗" border size="medium"></el-checkbox>
          <el-input v-if="checked4 == true"  onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[3].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px">
          <el-checkbox v-model="checked5" @change="checkbox(4,checked5,'保洁2小时')" label="保洁2小时" border size="medium"></el-checkbox> 
          <el-input v-if="checked5 == true"  onKeyUp="value=value.replace(/[\W]/g,'')"   style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[4].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px">
          <el-checkbox v-model="checked6" @change="checkbox(5,checked6,'保洁4小时')" label="保洁4小时" border size="medium"></el-checkbox>
          <el-input v-if="checked6 == true"  onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[5].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px">
          <el-checkbox v-model="checked7" @change="checkbox(6,checked7,'擦玻璃小户型（100平米下）')" label="擦玻璃小户型（100平米下）" border size="medium"></el-checkbox>
          <el-input v-if="checked7 == true" onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[6].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px"> 
          <el-checkbox v-model="checked8" @change="checkbox(7,checked8,'擦玻璃大户型（100-150平米）')"  label="擦玻璃大户型（100-150平米）" border size="medium"></el-checkbox>
          <el-input  v-if="checked8 == true" onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[7].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px"> 
          <el-checkbox v-model="checked9" @change="checkbox(8,checked9,'马桶/坐便疏通')"  label="马桶/坐便疏通" border size="medium"></el-checkbox>
          <el-input  v-if="checked9 == true" style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[8].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px"> 
          <el-checkbox v-model="checked10" @change="checkbox(9,checked10,'居家开锁')"  label="居家开锁" border size="medium"></el-checkbox>
          <el-input  v-if="checked10 == true" onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[9].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px"> 
          <el-checkbox v-model="checked11" @change="checkbox(10,checked11,'抽油烟机清洗')"  label="抽油烟机清洗" border size="medium"></el-checkbox>
          <el-input  v-if="checked11 == true" onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[10].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px"> 
          <el-checkbox v-model="checked12" @change="checkbox(11,checked12,'冰箱清洗')"  label="冰箱清洗" border size="medium"></el-checkbox>
          <el-input v-if="checked12 == true"  onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[11].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px"> 
          <el-checkbox v-model="checked13" @change="checkbox(12,checked13,'空调清洗')"  label="空调清洗" border size="medium"></el-checkbox>
          <el-input v-if="checked13 == true"  onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[12].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px"> 
          <el-checkbox v-model="checked14" @change="checkbox(13,checked14,'洗衣机清洗')"  label="洗衣机清洗" border size="medium"></el-checkbox>
          <el-input v-if="checked14 == true"  onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[13].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px"> 
          <el-checkbox v-model="checked15" @change="checkbox(14,checked15,'清洁口腔')"  label="清洁口腔" border size="medium"></el-checkbox>
          <el-input v-if="checked15 == true"  onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[14].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px"> 
          <el-checkbox v-model="checked16" @change="checkbox(15,checked16,'衣物干洗')"  label="衣物干洗" border size="medium"></el-checkbox>
          <el-input v-if="checked16 == true"  onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[15].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <div style="margin-top: 20px"> 
          <el-checkbox v-model="checked17" @change="checkbox(16,checked17,'全屋打扫')"  label="全屋打扫" border size="medium"></el-checkbox>
          <el-input v-if="checked17 == true"  onKeyUp="value=value.replace(/[\W]/g,'')"  style="display: inline-block;width: 200px;margin-left: 15px;" v-model="accidentTypes[16].amount" placeholder="请输入服务签约价"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addType()">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import {userlist_regulator,userwAddRegulators,userwEditRegulators,listSubRegulators,userdelSubRegulator,caseregulatorsave,regulatorsaveService,regulatorlistservice } from '@/views/axios/api.js'
  import constants from '@/util/constants.js';
  import axios from 'axios';
  import qs from "qs";
  export default {
    data() {
      return {
        contractEndTime:'',
        recognitionCode:'',
        checked1: false,
        checked2: false,
        checked3: false,
        checked4: false,
        checked5: false,
        checked6: false,
        checked7: false,
        checked8: false,
        checked9: false,
        checked10: false,
        checked11: false,
        checked12: false,
        checked13: false,
        checked14: false,
        checked15:false,
        checked16:false,
        checked17:false,
        checkboxGroup1: [],
        checkboxGroup2: [],
        accidentTypesIndex:[],
        accidentTypes: [
          {
            serviceType: "疏通马桶服务",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "开锁服务",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "油烟机清洗",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "油烟机拆洗",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "保洁2小时",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "保洁4小时",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "擦玻璃小户型（100平米下）",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "擦玻璃大户型（100-150平米）",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "马桶/坐便疏通",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "居家开锁",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "抽油烟机清洗",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "冰箱清洗",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "空调清洗",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "洗衣机清洗",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "清洁口腔",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "衣物干洗",
            amount:'',
            coin:'CNY'
          },
          {
            serviceType: "全屋打扫",
            amount:'',
            coin:'CNY'
          }
          ],
        insuranceCompanyId1:'',
        name:'',
        insuranceCompanyId:'',
        companies:[],
         id:'',
         name:'', //保险公司名称
         shortName:"", //简称
         contact:"", //联系人
         contactTel:"", //联系方式
        //  emailA:'ops@jiangtai.com',
         email:"", //操作联系邮箱
         email1:"",
         email2:"",
         email3:"",
        //  passport:"", //登录账号
         dialogFormVisible:false,
         dialogVisible:false,
         title:'',
         tableData:[],
         regulatorId:'',
         subRegulatorId:''
      };
    },
    methods: {
      checkbox(index,type,name) {
        if(type == true) {
          this.accidentTypesIndex.push( this.accidentTypes[index])
        }else {
          if(this.accidentTypesIndex.length > 0) {
            console.log(this.accidentTypesIndex)
            console.log(name)
            for(var i = 0; i<this.accidentTypesIndex.length; i++){
              if(this.accidentTypesIndex[i].serviceType == name) {
                console.log(this.accidentTypesIndex[i])
                this.accidentTypesIndex = this.accidentTypesIndex.filter(item => item.serviceType !== name);
              }
             
            }
          }
        }
        console.log( this.accidentTypesIndex)
      },
      addType() {
        
        if(this.checked17 == true) {
          if(this.accidentTypes[16].amount == '' || this.accidentTypes[16].amount == null || this.accidentTypes[16].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
        if(this.checked16 == true) {
          if(this.accidentTypes[15].amount == '' || this.accidentTypes[15].amount == null || this.accidentTypes[15].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
        if(this.checked15 == true) {
          if(this.accidentTypes[14].amount == '' || this.accidentTypes[14].amount == null || this.accidentTypes[14].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
        if(this.checked14 == true) {
          if(this.accidentTypes[13].amount == '' || this.accidentTypes[13].amount == null || this.accidentTypes[13].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
        if(this.checked13 == true) {
          if(this.accidentTypes[12].amount == '' || this.accidentTypes[12].amount == null || this.accidentTypes[12].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
        if(this.checked12 == true) {
          if(this.accidentTypes[11].amount == '' || this.accidentTypes[11].amount == null || this.accidentTypes[11].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
        if(this.checked11 == true) {
          if(this.accidentTypes[10].amount == '' || this.accidentTypes[10].amount == null || this.accidentTypes[10].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
        if(this.checked10 == true) {
          if(this.accidentTypes[9].amount == '' || this.accidentTypes[9].amount == null || this.accidentTypes[9].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
        if(this.checked9 == true) {
          if(this.accidentTypes[8].amount == '' || this.accidentTypes[8].amount == null || this.accidentTypes[8].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
          if(this.checked8 == true) {
          if(this.accidentTypes[7].amount == '' || this.accidentTypes[7].amount == null || this.accidentTypes[7].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
         if(this.checked7 == true) {
          if(this.accidentTypes[6].amount == '' || this.accidentTypes[6].amount == null || this.accidentTypes[6].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
        if(this.checked6 == true) {
          if(this.accidentTypes[5].amount == '' || this.accidentTypes[5].amount == null || this.accidentTypes[5].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
        if(this.checked5 == true) {
          if(this.accidentTypes[4].amount == '' || this.accidentTypes[4].amount == null || this.accidentTypes[4].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
         if(this.checked4 == true) {
          if(this.accidentTypes[3].amount == '' || this.accidentTypes[3].amount == null || this.accidentTypes[3].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
        if(this.checked3 == true) {
          if(this.accidentTypes[2].amount == '' || this.accidentTypes[2].amount == null || this.accidentTypes[2].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
        if(this.checked1 == true) {
          if(this.accidentTypes[0].amount == '' || this.accidentTypes[0].amount == null || this.accidentTypes[0].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
        if(this.checked2 == true) {
          if(this.accidentTypes[1].amount == '' || this.accidentTypes[1].amount == null || this.accidentTypes[1].amount == undefined) {
            this.$message({
            showClose: true,
            message: '请填写服务签约价',
            type: 'error',
            center: true,
            offset: 200,
            duration: 2000,
            customClass: 'widthMessage'
          })
          return
          }

        }
        // var str = '';
        // var sep = ',';
      
        for(var i = 0; i<this.accidentTypes.length; i++) {
          for (var j = 0; j < this.accidentTypesIndex.length; j++) {
            if(this.accidentTypes[i].serviceType == this.accidentTypesIndex[j].serviceType) {
              this.accidentTypesIndex[j].amount = Number(this.accidentTypes[i].amount)
             console.log(this.accidentTypes[i])
             console.log(this.accidentTypesIndex[j])
            }
          }
        }
        console.log(this.accidentTypesIndex)
        console.log(this.accidentTypes)
        // return
        // str = str.slice(0, -1);
        var obj = {
          regulatorId:this.regulatorId,
          subRegulatorId:this.subRegulatorId,
          token:JSON.parse(window.localStorage.getItem("data")).data,
          services:JSON.stringify(this.accidentTypesIndex)
        }
          let config = {
      		headers: {
      			"Content-Type": "application/json",
          //  "Access-Control-Allow-Headers":"*"
      		}
      	};
        axios({
            method: 'post',
            url: SEVSRS + 'rescue/case/regulator/saveService',
            headers: {
                'Content-type': 'application/json'
            },
            params: {
              regulatorId:this.regulatorId,
              subRegulatorId:this.subRegulatorId,
              token:JSON.parse(window.localStorage.getItem("data")).data,
              servicesInfo:JSON.stringify(this.accidentTypesIndex)
            }
        })
            .then((response) => {
                  this.dialogVisible = false
          this.$message({
          message: '添加成功',
          type: 'success'
          });
            })
            .catch((error) => {
                console.log(error);
            }
        );

      	// axios.post(SEVSRS + 'rescue/case/regulator/saveService', qs.stringify(obj),config)
      	// 	.then(res => {
      	// 		if (res.data.code == 0) {
      	// 			console.log(res)
      	// 		}
      	// 	})
      	// 	.catch(err => {
      	// 		console.log(err)
      	// 	})


        // regulatorsaveService(obj).then((res)=>{
        //   this.dialogVisible = false
        //   this.$message({
        //   message: '添加成功',
        //   type: 'success'
        // });
        //   console.log(res)
        // })
      },
      see() {
       this.getdata() 
      },
      dele(id) {
        userdelSubRegulator({token:JSON.parse(window.localStorage.getItem("data")).data,id:id}).then((res)=>{
         if(res) {
            this.$message({
          message: '删除保险机构成功',
          type: 'success'
        });
        this.getdata() 
         }
        })
      },
        suoshuFun() {
        console.log(this.insuranceCompanyId)
        // this.reportcase.regulatorId = this.reportcase.insuranceCompanyId;
      },
     getdata() {
        listSubRegulators({token:JSON.parse(window.localStorage.getItem("data")).data}).then((res)=>{
         this.companies = res.data.obj
         if(res){
               userlist_regulator({token:JSON.parse(window.localStorage.getItem("data")).data,name:this.seename,regulatorId:this.insuranceCompanyId1}).then((res)=>{
                 for(var i = 0; i<res.data.obj.length; i++) {
                   for(var j = 0; j<this.companies.length; j++) {
                     if(res.data.obj[i].regulatorId == this.companies[j].insti.id) {
                        res.data.obj[i].regulatorIdname = this.companies[j].insti.name
                     }
                   }
                 }
        //  console.log(res.data.obj[0].email.replace(/,/g,"\n"))
         this.tableData = res.data.obj
         console.log(this.companies)
       })
         }
       })
     },
     add() {
       this.name = "", //保险公司名称
       this.shortName = "", //简称
       this.contact = "", //联系人
       this.contactTel = "", //联系方式
       this.email = "", //操作联系邮箱
       this.recognitionCode = "",
       this.contractEndTime = "",
      //  this.passport = "", //登录账号
       this.id = "",
      this.email1 = "",
      // this.emailA = 'ops@jiangtai.com',
      this.email2 = "",
      this.email3 = "",
       this.title = '添加保险机构'
       this.dialogFormVisible = true
     },
     type(item) {
      this.checked1 = false;
      this.checked2 = false;
      this.checked3 = false;
      this.checked4 = false;
      this.checked5 = false;
      this.checked6 = false;
      this.checked7 = false;
      this.checked8 = false;
      this.dialogVisible = true
      this.regulatorId = item.regulatorId
      this.subRegulatorId = item.id
      if(item.id != '' && item.id != null && item.id != undefined) {
        regulatorlistservice({
        token:JSON.parse(window.localStorage.getItem("data")).data,
        regulatorId:item.regulatorId,
        subRegulatorId:item.id
      }).then((res)=>{
        console.log(res)
        this.accidentTypesIndex = res.data.obj
        for(var j =0; j<this.accidentTypes.length; j++) {
          this.accidentTypes[j].amount = ''
        }
        for(var i = 0; i<res.data.obj.length; i++) {
          if(res.data.obj[i].serviceType=='疏通马桶服务') {
            this.accidentTypes[0].amount = res.data.obj[i].amount
            this.checked1 = true
          }else if(res.data.obj[i].serviceType=='开锁服务') {
             this.accidentTypes[1].amount = res.data.obj[i].amount
            this.checked2= true
          }else if(res.data.obj[i].serviceType=='油烟机清洗') {
            this.accidentTypes[2].amount = res.data.obj[i].amount
            this.checked3= true
          }else if(res.data.obj[i].serviceType=='油烟机拆洗') {
            this.accidentTypes[3].amount = res.data.obj[i].amount
            this.checked4= true
          }else if(res.data.obj[i].serviceType=='保洁2小时') {
            this.accidentTypes[4].amount = res.data.obj[i].amount
            this.checked5= true
          }else if(res.data.obj[i].serviceType=='保洁4小时') {
            this.accidentTypes[5].amount = res.data.obj[i].amount
            this.checked6= true
          }else if(res.data.obj[i].serviceType=='擦玻璃小户型（100平米下）') {
            this.accidentTypes[6].amount = res.data.obj[i].amount
            this.checked7= true
          }else if(res.data.obj[i].serviceType=='擦玻璃大户型（100-150平米）') {
            this.accidentTypes[7].amount = res.data.obj[i].amount
            this.checked8= true
          }else if(res.data.obj[i].serviceType=='马桶/坐便疏通') {
            this.accidentTypes[8].amount = res.data.obj[i].amount
            this.checked9= true
          }else if(res.data.obj[i].serviceType=='居家开锁') {
            this.accidentTypes[9].amount = res.data.obj[i].amount
            this.checked10= true
          }else if(res.data.obj[i].serviceType=='抽油烟机清洗') {
            this.accidentTypes[10].amount = res.data.obj[i].amount
            this.checked11= true
          }else if(res.data.obj[i].serviceType=='冰箱清洗') {
             this.accidentTypes[11].amount = res.data.obj[i].amount
            this.checked12= true
          }else if(res.data.obj[i].serviceType=='空调清洗') {
            this.accidentTypes[12].amount = res.data.obj[i].amount
            this.checked13= true
          }else if(res.data.obj[i].serviceType=='洗衣机清洗') {
            this.accidentTypes[13].amount = res.data.obj[i].amount
            this.checked14= true
          }else if(res.data.obj[i].serviceType=='清洁口腔') {
            this.accidentTypes[14].amount = res.data.obj[i].amount
            this.checked15= true
          }else if(res.data.obj[i].serviceType=='衣物干洗') {
            this.accidentTypes[15].amount = res.data.obj[i].amount
            this.checked16= true
          }else if(res.data.obj[i].serviceType=='全屋打扫') {
            this.accidentTypes[16].amount = res.data.obj[i].amount
            this.checked17= true
          }
        }
        console.log(res.data.obj)
      })
      }
     },
     edit(item) {
       /** @type {string[]} 邮箱可能为 null/undefined，需安全拆分 */
       var emaillist = (item.email != null && item.email !== '' ? String(item.email) : '').split(',')
       this.recognitionCode = item.recognitionCode
       this.contractEndTime = item.contractEndTime
       this.name = item.name, //保险公司名称
       this.shortName = item.shortName, //简称
       this.contact = item.contact, //联系人
       this.contactTel = item.contactTel, //联系方式
       this.email = emaillist[0] || '', //操作联系邮箱
       this.email1 = emaillist[1] || '', 
       this.email2= emaillist[2] || '', 
       this.email3= emaillist[3] || '', 
       this.insuranceCompanyId = item.regulatorId
       this.id = item.id
       this.title = '编辑保险机构'
       this.dialogFormVisible = true
     },
     sureFun() {
       var ema = ''
       var emaList = []
      //  if(this.email == '') {
      //   ema = this.email1+ ',' + this.email2+ ',' + this.email3+ ',' +this.emailA
      //  }else if(this.email == '' || this.email1 == '' ){
      //      ema = this.email2+ ',' + this.email3+ ',' +this.emailA
      //  }else if(this.email == '' || this.email1 == ''|| this.email2 == '' ){
      //      ema =  this.email3+ ',' +this.emailA
      //  }else if(this.email == '' || this.email1 == ''|| this.email2 == '' || this.email3 == ''){
      //      ema =  this.emailA
      //  }else if(this.email1 == ''){
      //      ema = this.email + ',' + this.email2+ ',' + this.email3+ ',' +this.emailA
      //  }else if(this.email1 == '' || this.email2 == ''){
      //      ema = this.email + ','  + this.email3+ ',' +this.emailA
      //  }else if(this.email1 == '' || this.email2 == '' || this.email3 == ''){
      //      ema = this.email + ','  +this.emailA
      //  }else if(this.email2 == '') {
      //    ema = this.email + ',' + this.email1+ ','  + this.email3+ ',' +this.emailA
      //  }else if(this.email2 == ''|| this.email3 == '') {
      //    ema = this.email + ',' + this.email1+ ',' +this.emailA
      //  }else if(this.email3 == '') {
      //        ema = this.email + ',' + this.email1+ ','  + this.email2+ ',' +this.emailA
      //  }
      if(this.email != '' && this.email != null && this.email != undefined) {
        emaList.push(this.email)
      }
      if(this.email1 != '' && this.email1 != null && this.email1 != undefined) {
        emaList.push(this.email1)
      }
     if(this.email2 != '' && this.email2 != null && this.email2 != undefined) {
        emaList.push(this.email2)
      }
      if(this.email3 != '' && this.email3 != null && this.email3 != undefined) {
        emaList.push(this.email3)
      }
      // return
       if(this.name == "") {
         this.$message.error('保险公司名称必填');
         return
       }
       if(this.title == '添加保险机构') {
        var contractEndTime =  new Date(this.contractEndTime).getTime() + 86399000;
              userwAddRegulators({
         token:JSON.parse(window.localStorage.getItem("data")).data,
         name:this.name,
         shortName:this.shortName,
         contact:this.contact,
         contactTel:this.contactTel,
         recognitionCode:this.recognitionCode,
         contractEndTime:contractEndTime,
         email:emaList.length > 0 ? emaList.join(",") : "",
        //  passport:this.passport,
         regulatorId:this.insuranceCompanyId
       }).then((res)=>{
         if(res) {
            this.$message({
          message: '添加保险机构成功',
          type: 'success'
        });
        this.dialogFormVisible = false
        this.getdata()
         }
         console.log(res)
       })
     }else {
      var contractEndTime =  new Date(this.contractEndTime).getTime()  + 86399000;
        userwAddRegulators({
         token:JSON.parse(window.localStorage.getItem("data")).data,
         id:this.id,
         name:this.name,
         shortName:this.shortName,
         contact:this.contact,
         contactTel:this.contactTel,
         recognitionCode:this.recognitionCode,
         contractEndTime:contractEndTime,
         email:emaList.length > 0 ? emaList.join(",") : "",
        //  passport:this.passport,
         regulatorId:this.insuranceCompanyId
       }).then((res)=>{
             if(res) {
            this.$message({
          message: '编辑保险机构成功',
          type: 'success'
        });
        this.dialogFormVisible = false
        this.getdata()
         }
        })
     }
       }
     
      
    },
    mounted() {
      this.getdata()
    }
  };
</script>

<style scoped>
.popBox li{margin-bottom: 10px;}
.popBox .el-input{width: 300px;}
.popBox span{display: inline-block;width: 125px;text-align: right;}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/star/Insurancemanagement.vue